import { useEffect } from 'react'
import { useAppSelector } from '@/hooks/redux'
import { refreshCoordinator } from './refreshCoordinator'
import { startRefreshConnection } from './refreshConnection'

/** Mount once under the authenticated layout, outside remounting route content. */
export function RefreshHost() {
  const userId = useAppSelector(state => state.user.userId)
  useEffect(() => {
    if (!userId) { refreshCoordinator.suspend(); return }
    let sessionEnded = false
    const resume = () => {
      if (!sessionEnded && navigator.onLine && !document.hidden) refreshCoordinator.resume()
    }
    const logout = () => { sessionEnded = true; refreshCoordinator.suspend() }
    resume()
    window.addEventListener('auth:unauthorized', logout)
    window.addEventListener('online', resume)
    window.addEventListener('focus', resume)
    document.addEventListener('visibilitychange', resume)
    const base = import.meta.env.VITE_WS_BASE as string | undefined
    const stop = base ? startRefreshConnection(`${base.replace(/\/$/, '')}/ws/events`,
      (resources, reason) => refreshCoordinator.invalidate(resources, reason)) : undefined
    return () => {
      stop?.(); refreshCoordinator.suspend()
      window.removeEventListener('auth:unauthorized', logout)
      window.removeEventListener('online', resume)
      window.removeEventListener('focus', resume)
      document.removeEventListener('visibilitychange', resume)
    }
  }, [userId])
  return null
}
